export default __webpack_public_path__ + "static/media/platinum.8508d2b5.jpg";